<template>
  <div>
    <h1 class="mt-4">{{ $t("checkEmail") }}</h1>
    <p class="mt-4 text-center">
      <strong>{{ $t("passwordEmail") }}</strong>
    </p>

    <p class="mt-5 mb-3 ml-3">
      <router-link to="/">{{ $t("back") }}</router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: "passwordResetDone"
};
</script>
<style scoped lang="scss"></style>
